import { ContentfulImageAPI } from '@toasttab/shared/src/utils/contentfulUtils'

interface TransformImageProps {
  height?: number
  width?: number
  q?: number | undefined
  focusArea?: string
  resize?: 'scale' | 'fit' | 'fill' | 'crop' | 'thumb'
  extension?: string
}

const transformImageAvif = ({
  width,
  height,
  q = undefined,
  resize = 'scale',
  focusArea,
  extension = ''
}: TransformImageProps = {}) => {
  if (extension === 'image/svg+xml' || extension === 'video/mp4') {
    return ''
  }
  return `?fm=avif${height ? `&h=${height}` : ''}${width ? `&w=${width}` : ''}${
    q ? `&q=${q}` : ''
  }${resize ? `&fit=${resize}${focusArea ? `&f=${focusArea}` : ''}` : ''}`
}

interface TransformImageAvifSrcsetProps {
  url: string
  widths?: number[]
  heights?: number[]
  q?: number | undefined
  focusArea?: string
  resize?: 'scale' | 'fit' | 'fill' | 'crop' | 'thumb'
  extension?: string
}

const transformImageAvifSrcset = ({
  url,
  widths = [320, 640, 768, 1024, 1280, 1536, 1920],
  heights,
  q = undefined,
  resize = 'scale',
  focusArea,
  extension = ''
}: TransformImageAvifSrcsetProps) => {
  if (extension === 'image/svg+xml' || extension === 'video/mp4') {
    return ''
  }
  return widths
    .map((width: number, i: number) => {
      // attempting mapping height
      const height = heights && heights[i]
      if (height) {
        return `${url}${transformImageAvif({
          width,
          height,
          q,
          resize,
          focusArea,
          extension
        })} ${width}w ${height}h`
      }
      return `${url}${transformImageAvif({
        width,
        q,
        resize,
        focusArea,
        extension
      })} ${width}w`
    })
    .join(', ')
}

const createImageFromAsset = (asset: any) => {
  let query = ''
  const url = asset.desktop?.file.url || asset.file?.url
  let srcsetAvif = url
  if (asset.desktop?.file.contentType === 'image/png') {
    query = ContentfulImageAPI.transformImageAvif()
    srcsetAvif = ContentfulImageAPI.transformImageAvifSrcset({
      url: asset.desktop?.file.url,
      widths: [320, 640]
    })
  }

  return {
    typeHandle: 'image',
    extension: asset.desktop?.file.contentType,
    url,
    title: asset.title,
    imgClasses: 'rounded-lg',
    optimizedImages: {
      src: '',
      srcset: url,
      srcsetMaxWidth: '',
      srcsetAvif,
      placeholderBox: '',
      placeholderImage: '',
      maxSrcsetWidth: '',
      srcAvif: asset.desktop?.file.url + query
    }
  }
}

export { createImageFromAsset, transformImageAvif, transformImageAvifSrcset }
